import HomeAssumptionsZurichOwnLivePage from './HomeAssumptionsZurichOwnLivePage';

export default HomeAssumptionsZurichOwnLivePage;
